import { PaymentHistoryPage } from "./payment-history/payment-history";
import { MembershipService } from "./membership/membership.service";
import {
  NavController,
  AlertController,
  App,
  NavParams,
  ModalController,
} from "ionic-angular";
import { Component, ViewChild } from "@angular/core";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { AccountPage } from "./account/account";
import { ReferralPage } from "./referral/referral";
import { MembershipPage } from "./membership/membership";
import { GymsPage } from "./gyms/gyms";
import { SignInPage } from "./../../auth/sign-in/sign-in";
import { SessionService } from "./../../../services/session";
import { AuthService } from "./../../../services/auth";
import { BackendModule } from "./../../../modules/backend.module";
import { CameraPage } from "../shared/camera/camera";
import { ToastController } from "ionic-angular";
import { LocationsService } from "../../../services/locations";
import { ComplementsPage } from "./membership/complements";
// pwa/app difference: App uses Ionic native camera, clipboard and emailcomposer

@Component({
  selector: "page-profile",
  templateUrl: "profile.html",
})
export class ProfilePage {
  @ViewChild("file") file: any;

  accountPage = AccountPage;
  membershipPage = MembershipPage;
  beautyMembershipPage = ComplementsPage;
  referralPage = ReferralPage;
  signinPage = SignInPage;
  paymentHistoryPage = PaymentHistoryPage;
  gymsPage = GymsPage;
  uploadingImage = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private iab: InAppBrowser,
    public sessionService: SessionService,
    public backendModule: BackendModule,
    public authService: AuthService,
    public app: App,
    public membershipService: MembershipService,
    public toastCtrl: ToastController,
    public locationsService: LocationsService
  ) {}

  ionViewDidEnter() {
    if (this.membershipService.goToMembership) {
      this.GoTo(this.membershipPage);
      this.membershipService.goToMembership = false;
    }

    console.debug("Accessing to the Profile");
    this.authService.getUserInfo(this.sessionService.user.id).then(() => {
      console.debug(
        "New user info retrieved, now about to get membership info"
      );
      this.membershipService.getPrice();
    });
  }

  canSeeMembership() {
    return !this.sessionService.user.plan_type.startsWith("tp");
  }

  canSeeBeautyMembership() {
    return !this.sessionService.user.plan_type.startsWith("tp");
  }

  openBrowser(url, target = "_blank") {
    this.iab.create(url, target);
  }

  GoTo(page, display?: "favorites" | "trending") {
    this.navCtrl.push(page, { display });
  }

  onChangePic() {
    let prompt = this.alertCtrl.create({
      title: "Seleccionar Imagen",
      buttons: [
        {
          text: "Camara",
          handler: (data) => {
            this.chooseFrom("camera");
          },
        },
        {
          text: "Carrete",
          handler: (data) => {
            this.chooseFrom("files");
          },
        },
      ],
    });
    prompt.present();
  }

  chooseFrom(source) {
    if (source === "files") {
      console.log("select file");
      let el: HTMLElement = this.file.nativeElement as HTMLElement;
      el.click();
    } else if (source === "camera") {
      let modal = this.modalCtrl.create(
        CameraPage,
        {},
        { cssClass: "smaller-modal" }
      );
      modal.onDidDismiss((imageData) => {
        if (imageData) {
          this.uploadImage(imageData);
        }
      });
      modal.present();
    }
  }

  uploadImage(imageData) {
    this.uploadingImage = true;
    let userId = this.sessionService.user.id;
    // let url = "data:image/jpeg;base64," + imageData;
    let url = imageData;
    this.sessionService.user.picture_url = url;
    this.backendModule
      .putAPI(`users/${userId}`, {
        user: { picture: url },
      })
      .subscribe(() => {
        this.uploadingImage = false;
        (err) => {
          this.sessionService.reportError("profilePage", "uploadImage()", err);
          this.uploadingImage = false;
          console.log(err);
        };
      });
  }

  onLogOut() {
    this.app.getRootNav().setRoot(this.signinPage);
    this.authService.logOut();
  }

  ionViewDidLoad() {
    window["page"] = "ProfilePage"; // for GA
  }

  //dragging files
  onFilesChange(file) {
    this.uploadImage(file);
  }

  //selecting files
  onFileWillChange(file) {
    this.getBase64(file.target.files[0])
      .then((base64) => {
        this.uploadImage(base64);
      })
      .catch((err) => {
        this.sessionService.reportError(
          "profilePage",
          "onFileWillChange()",
          err
        );
      });
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  onShareReferral() {
    window.navigator.clipboard
      .writeText(this.membershipService.referralCode)
      .then(() => {
        this.presentToast();
        this.GoTo(this.referralPage);
      })
      .catch((err) => {
        this.GoTo(this.referralPage);
        this.sessionService.reportError(
          "profilePage",
          "onShareReferral()",
          err
        );
      });
  }

  presentToast() {
    const toast = this.toastCtrl.create({
      message: "Copied to clipboard",
      duration: 3000,
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/profile.ts